import { useAtom } from "jotai";
import React from "react";

import { handleAssetUrl } from "../../../shared/utils";
import { socialReferralPageAtom } from "../../social-referral.state";

export const SocialReferralSubHeader: React.FC = () => {
  const [socialReferralPage] = useAtom(socialReferralPageAtom);
  const { sweepstakeTitle, sweepstakePrice } = window.FKL;

  return (
    <div className="social-referral__subheader">
      <div className="social-referral-subheader__text">
        <div className="social-referral-subheader__title">
          {"REFER FRIENDS"} <span className="desktop-text">{"&"}</span>
          <br className="mobile-br" /> {"GET"}{" "}
          <span className="social-referral-gradient__text">EXTRA ENTRIES</span>
        </div>
        <div className="social-referral-subheader__sweep-title">{`${sweepstakePrice} ${sweepstakeTitle}`}</div>
        <div className="social-referral-subheader__description">
          {`Earn ${socialReferralPage.social_referral_extra_entries} extra entries
          for each friend that enters the giveaway with your link. Plus, they'll
          get ${socialReferralPage.social_referral_extra_entries} extra entries
          when they sign up with your link!`}
        </div>
        <div className="social-referral-subheader__max-entries-copy">
          {`*Up to a maximum of ${
            socialReferralPage.social_referral_max_extra_entries ?? 0
          } referral entries`}
        </div>
      </div>
      <div className="social-referral-subheader__image-column">
        <img
          className="social-referral-subheader__icon"
          src={handleAssetUrl("referral-page-image.png")}
          alt="Referral subheader icon"
        />
      </div>
    </div>
  );
};
